import "vuetify/lib/styles/main.css";
import "@mdi/font/css/materialdesignicons.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import { router } from "@/service/router";
import { createVuetify} from 'vuetify'
import { createApp } from "vue";
import VueScrollTo from "vue-scrollto";
import { store } from "./store/index";
import App from "./App";
import axios from "axios";
import VueAxios from "vue-axios";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import lodash from "lodash";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import "@fontsource/montserrat";
import AvatarCropper from "vue-avatar-cropper";
import VueAwesomePaginate from "vue-awesome-paginate";
import "vue-awesome-paginate/dist/style.css";
import MasonryWall from "@yeger/vue-masonry-wall";
import Vue3VideoPlayer from "@cloudgeek/vue3-video-player";
import "@cloudgeek/vue3-video-player/dist/vue3-video-player.css";


const myLang = {
  dashboard: {
    btn: {
      play: "Запустить",
      pause: "Пауза",
      fullscreen: "Полноэкранный режим",
      exitFullscreen: "Выйти из полноэкранного режима",
      mute: "Выключить звук",
      unmute: "Включить звук",
      back: "Назад",
      pip: "Картинка в картинке",
    },
    settings: {
      autoplay: "Автопроигрывание",
      loop: "Повтор",
      speed: "Скорость",
      resolution: "Размер",
    },
  },
  layers: {
    error: {
      title: "Ошибка!",
      2404: "Video Source Undefined",
      2502: "Media Network Error",
      2503: "Video Cannot DECODE",
      2504: "Видео не может воспроизвестись!",
      601: "Live видео не может воспроизвестись!",
    },
    loading: {
      msg: "Загрузка ...",
    },
  },
};

import { createPinia } from "pinia";
const pinia = createPinia();


const app = createApp(App);

import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
const myCustomLightTheme = {
  dark: false,
  colors: {
    background: "#FFFFFF",
    surface: "#FFFFFF",
    primary: "#FA9DB7",
    "primary-darken-1": "#3700B3",
    secondary: "#03DAC6",
    "secondary-darken-1": "#018786",
    error: "#B00020",
    info: "#2196F3",
    success: "#4CAF50",
    warning: "#FB8C00",
    "primary-dark": "#9C7CA9",
    "chat-bg": "#6E6D94",
    main: "#fff",
  },
};

const vuetify = createVuetify({ 
  components, 
  directives,
})

app.use(router);
app.use(vuetify)
app.use(pinia);
app.use(Vue3VideoPlayer, {lang: myLang});
app.use(MasonryWall);
app.use(lodash);
app.use(VueAxios, axios);
app.config.globalProperties.$axios = axios;
app.use(store);
app.use(AvatarCropper);
app.component("datePicker", Datepicker);
app.component("font-awesome-icon", FontAwesomeIcon);
app.use(VueAwesomePaginate);
app.use(VueScrollTo);

app.mount("#app");
